import './Banners.scss';

export const Banners = () => {
  return (
    <div className="banners">
      <div className="dynamic-banners">
        <div className="shiny-ad">
          <div className="ad-placeholder">Your Ad Here</div>
          <div className="payment-container hidden">
            <textarea
              className="input-textarea"
              placeholder="Your text ... [max 200 chars]"
              rows={3}
            />
            <input className="input-url" type="url" placeholder="Enter PROJECT LINK ..." />
            <input className="input-url" type="url" placeholder="Enter PICTURE URL ..." />
            <div className="inline-elements">
              <select className="dropdown">
                <option value="10 HIVE">10 HIVE</option>
                <option value="2 HBD">2 HBD</option>
                <option value="2100 DOOM">2100 DOOM</option>
              </select>
              <select className="dropdown">
                <option value="1 WEEK">1 WEEK</option>
                <option value="1 MONTH">1 MONTH</option>
              </select>
              <button className="pay-button">LIST IT</button>
            </div>
          </div>
        </div>
        <div className="ad-preview shiny-ad hidden">
          <label>Preview:</label>
          <br/><br/><br/><br/><br/><br/>
        </div>
      </div>

      <div className="paid-ad2 hidden">
        <sub style={{ fontSize: '10px', color: 'yellow' }}>PAID AD</sub>
        <div>
          <p>BET ON YOUR CHESS MATCHES USING OUR HIVE BOT: peakd.com/@hivebets</p>
        </div>
      </div>

      <div className="vote-our-posts">
        Our last posts:
        <br/>https://peakd.com/@cryptoshots.nft <button>Upvote</button>
        <br/>https://peakd.com/@cryptoshots.play <button>Upvote</button>
      </div>
    </div>
  );
};
